import { useState, useEffect } from 'react';
import { useRelatoriosProfessorPage } from './useRelatoriosProfessorPage';
import { RelatoriosProfessorDesktop } from './RelatoriosProfessorDesktop';
import { RelatoriosMobileView } from './RelatoriosMobileView';

function useIsMobile(bp = 768) {
  const [m, setM] = useState(() =>
    typeof window !== 'undefined' ? window.innerWidth < bp : false,
  );
  useEffect(() => {
    const fn = () => setM(window.innerWidth < bp);
    window.addEventListener('resize', fn);
    return () => window.removeEventListener('resize', fn);
  }, [bp]);
  return m;
}

export function RelatoriosProfessorPage() {
  const isMobile = useIsMobile();
  const ctx = useRelatoriosProfessorPage();

  if (!isMobile) {
    return (
      <div
        className="rel-desk-host"
        style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}
      >
        <RelatoriosProfessorDesktop ctx={ctx} />
      </div>
    );
  }

  return <RelatoriosMobileView ctx={ctx} />;
}
